/** 画面エンティティ */
export class WebReserveDetailEntity {

  /** 予約ステータス */
  webReserveStatus: string;

  /** 予約希望日時 */
  reserveDateStartTime: string;

  /** 予約番号 */
  webReserveDispNum: string;

  /** お名前 */
  customerName: string;

  /** フリガナ */
  customerNameKana: string;

  /** 電話番号 */
  contactTelInformation: string;

  /** メールアドレス */
  contactEmailInformation: string;

  /** 住所 */
  address: string;

  /** 電話連絡可能な時間帯 */
  contactEnableTime: string;

  /** サービス */
  itemServiceName: string;

  /** お車のナンバー */
  registrateNum: string;

  /** メーカー */
  blVehicleMakerFullWFixNm: string;

  /** 車種 */
  vehicleModelFixFullWName: string;

  /** 車検満了日 */
  vehicleInspectionExpirationDate: string;

  /** 代車 */
  replacementVehicle: string;

  /** チケットコード */
  ticketCode: string;

  /** チケット名称 */
  ticketName: string;

  /** 紹介者コード */
  introducerCode: string;

  /** 紹介者名 */
  introducerName: string;

  /** 紹介者名カナ */
  introducerNameKana: string;

  /** 顧客コード */
  customerCode: number;

  /** 顧客名称１ */
  customerName1: string;

  /** 顧客名称カナ１ */
  customerNameKana1: string;

  /** ご質問・ご希望など（備考） */
  note: string;

  /** キャンセル日 */
  cancelDate: string;

  /** キャンセル理由 */
  cancelReason: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-detail/web-reserve-detail.entity.ts